import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import HealthDashboardStore from './health-dashboard-page-store';
import ErrorDistributionTable from './components/error-distribution-table/error-distribution-table';
import { Button } from '../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../components/inputs/button-variants';
import './health-dashboard-page.scss';
import HealthStatsCard from "./components/health-stats-card/health-stats-card";

interface IHealthDashboardPageProps {
}

const HealthDashboardPage: React.FC<IHealthDashboardPageProps> = observer(() => {
    useEffect(() => {
        HealthDashboardStore.fetchErrorDistribution(undefined, HealthDashboardStore.selectedDays);
        HealthDashboardStore.fetchHealthStats(HealthDashboardStore.selectedDays);
    }, []);

    const handleTimeFrameChange = (days: number) => {
        HealthDashboardStore.setSelectedDays(days);
        HealthDashboardStore.fetchErrorDistribution(undefined, days);
        HealthDashboardStore.fetchHealthStats(days);
    };

    return (
        <BasePageLayout title="Account Health">
            <div className="health-dashboard-page">
                <div className="content">
                    <div className="time-frame-selector">
                        {HealthDashboardStore.timeFrameOptions.map((option) => (
                            <Button
                                key={option.days}
                                variant={HealthDashboardStore.selectedDays === option.days ? BUTTON_VARIANTS.Primary : BUTTON_VARIANTS.Secondary}
                                onClick={() => handleTimeFrameChange(option.days)}
                                text={option.label}
                            />
                        ))}
                    </div>
                    
                    <div className="health-stats-section">
                        <HealthStatsCard
                            healthStats={HealthDashboardStore.errorRatio}
                            isLoading={!HealthDashboardStore.errorRatio}
                        />
                    </div>
                    <div className="flex1">
                        <ErrorDistributionTable 
                            errorDistribution={HealthDashboardStore.errorDistribution}
                            isLoading={!HealthDashboardStore.errorDistribution}
                        />
                    </div>
                </div>
            </div>
        </BasePageLayout>
    );
});

export default HealthDashboardPage;
